import { PagingInputDTO } from '../../common.models/pagingInputDTO.model';

export class ProductPagingInputDTO extends PagingInputDTO {
    productTypeId: number;

    constructor() {
        super();

        this.productTypeId = 0;
    }
}